import { render, staticRenderFns } from "./oderManager.vue?vue&type=template&id=97c50d4a&scoped=true&"
import script from "./oderManager.vue?vue&type=script&lang=js&"
export * from "./oderManager.vue?vue&type=script&lang=js&"
import style0 from "./oderManager.vue?vue&type=style&index=0&id=97c50d4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97c50d4a",
  null
  
)

export default component.exports